module.exports = __webpack_public_path__ + "static/media/Shutter 3.df2d23b5.png";